export default __webpack_public_path__ + "static/media/success.ba98f7b9.png";